import Vue                  from "vue";
import { mapGetters }       from "vuex";
import { formatDateTime }   from "@/components/mixins";
import moment               from "moment";
import { MediaService }     from "@/services"
import { LoadingSpinner }   from "@/components"
import { DnFunctionButton } from "@/components/Elements"
import { WysiwygHtmlArea }  from "@/components/Elements/WysiwygHtmlArea"


export default Vue.extend({
    name: "NewsStory",
    components: { 
        LoadingSpinner,
        DnFunctionButton,
        WysiwygHtmlArea
    },
    mixins: [formatDateTime],
    props: {
        newsStory: {
            type: Object,
            default: null
        },
        isLoading: Boolean
    },
    computed: {
        ...mapGetters([ 
            "getContentItem" 
        ]),
        imageUrl () {
            return MediaService.getMediaUrl(this.newsStory.ImageId);
        },
        storyUrl () {
            const baseUrl = location.origin;
            return `${baseUrl}/news?queryStoryId=${this.newsStory.Id}`;
        }
    },
    methods: {
        formatNewsStoryDate: function(value: string | Date) {
            return moment(value).format("MMMM Do, YYYY");
        },
        copyUrl() {
            const selBox = document.createElement('textarea');
            selBox.style.position = 'fixed';
            selBox.style.left = '0';
            selBox.style.top = '0';
            selBox.style.opacity = '0';
            selBox.value = this.storyUrl;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            document.execCommand('copy');
            document.body.removeChild(selBox);
        },
        hasImage() {
           if(this.newsStory.ImageId == 0 || this.newsStory.ImageId == null){
               return false;
           }
           else{
               return true;
           }
        }
    },
    watch: {
    },
});
